var searchFormInputElement = document.querySelector('[name=search]');
var searchFormBlurTimeout;
document.querySelector('.header-search-box form').addEventListener('submit', function (e) {
    searchFormInputElement.focus();
}, true);
searchFormInputElement.addEventListener('invalid', function (e) {
    e.preventDefault();
    e.target.focus();
}, true);
searchFormInputElement.addEventListener('focus', function (e) {
    clearTimeout(searchFormBlurTimeout);
    document.querySelectorAll('.header-search-box input, .header-search-box button')
        .forEach(function (element) {
            element.style.borderBottom = '1px solid #ffffff';
        })
    document.querySelector('.header-search-box input')
        .style.width = '200px';
});
searchFormInputElement.addEventListener('blur', function (e) {
    searchFormBlurTimeout = setTimeout(function () {
        document.querySelectorAll('.header-search-box input, .header-search-box button')
            .forEach(function (element) {
                element.style.borderBottom = '1px solid transparent';
            });
        document.querySelector('.header-search-box input')
            .style.width = 0;
    }, 500);
});